export var DashboardReportType;
(function (DashboardReportType) {
    DashboardReportType["MALFUNCTIONS"] = "malfunctions";
    DashboardReportType["OFFLINE"] = "offline";
    DashboardReportType["LOW_BATTERY"] = "low_battery";
    DashboardReportType["CONTROLS"] = "controls";
    DashboardReportType["OTHER"] = "other";
})(DashboardReportType || (DashboardReportType = {}));
